// extracted by mini-css-extract-plugin
export default {"wrapper":"_820160e","contentFormatting":"_93cde803","close":"_2f797a4b","label":"_efcaf4bb","content":"_51f19494"};